export const isTouch = () => typeof window !== "undefined" && window.matchMedia("(hover: none)").matches;
